<template>
  <template v-if="$page">
    <section class="section -less-pad -center" v-if="$page">
      <h1 class="section__header" v-reveal>{{ $page.header.title }}</h1>
      <p class="section__text" v-reveal="{ delay: 225 }">{{ $page.header.description }}</p>
      <a
        href="mailto:info@voyagesaplus.com"
        target="_blank"
        class="button -right section__button"
        v-reveal="{ delay: 250 }"
      >
        {{ $page.header.btn_text }}
        <div class="button__icon">
          <Icon id="arrow" />
        </div>
      </a>
    </section>

    <PageBuilder v-if="$page" :sections="$page.sections" />
  </template>

  <template v-else>
    <Loader />
  </template>
</template>

<script>
import Loader from '@/components/blocks/Loader.vue'
import Icon from '@/components/global/Icon.vue'
import PageBuilder from '@/components/PageBuilder.vue'
import { setMeta } from '@/helpers/metaHelpers'

export default {
  name: 'Conseils',
  components: { Icon, Loader, PageBuilder },
  beetPage: 'advices',
  watch: {
    $page(to) {
      setMeta(to.seo)
    },
  },
  beforeMount() {
    if (this.$page) setMeta(this.$page.seo)
  },
}
</script>
